module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Cw6mFx/tc-custom/9781398468894.jpg?1705766067023",
      "alt": "This image is the cover for the book Sex, Drugs and Rock ‘n’ Roll – Memoir of a Police Doctor"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sex, Drugs and Rock ‘n’ Roll – Memoir of a Police Doctor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("I can claim to have enjoyed a satisfying and fulfilling medical career. British General Practice was the jewel in the NHS crown and I was a Family Doctor during its heyday before the Government decided to take control and tell the doctors how to do their job, demoralize the profession and seriously compromise patient care, destroying the respect between patients and their doctors and turning a vocation into a chore. I was fortunate that I began my career at the right time and got out at the right time. My almost thirty years working with the local police force was hard work but once I’d seen a few corpses and gained the respect of the local constabulary I enjoyed the work immensely even if I was so often denied a good night’s sleep. The case load varied from the gruesome to the amusing but looking back it was never boring. "), _c('br'), _vm._v("Sex, Drugs and Rock 'n' Roll – Memoir of a Police Doctor is an account of my experience as a Forensic Physician – a facet of the rich tapestry of medical practice that Joe Public never realized existed.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Wesley Boff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Wesley Boff is the pseudonym of Dr Terry Moore. He spent his medical career in South Yorkshire working as a family doctor and, for almost thirty years, he contracted to provide forensic physician services to his local police force. He lives in Florida.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0